module.exports = __webpack_public_path__ + "cf51f73026a31249584a68659cdea172.woff2";